
import React, { useContext, Children, useState, useEffect } from 'react'
import { GlobalContext } from '../GlobalContext'
import { Link, useParams } from 'react-router-dom'
import Button from '../formfields/Button'
import Spinner from '../ui-elements/Spinner'
import DisplayAverage from '../dashboard/DisplayAverage'



type Props = {
  questionId?: string
  setQuestionAnswer: React.Dispatch<React.SetStateAction<any>>
  defaultValue: null | string | string[]
  questionAnswerValue?: any
}

function QuestionNumber({
  questionId,
  setQuestionAnswer,
  questionAnswerValue,
  defaultValue
}: Props) {

  const {
    tableData
  } = useContext(GlobalContext)
  const { checkPeriodId } = useParams()
  const thisQuestion = questionId && tableData && tableData['ChecklistQuestions'] && tableData['ChecklistQuestions'][questionId]


  const togglePositiveOrNegative = () => {
    if (thisQuestion) {
      const currentValue = questionAnswerValue || defaultValue
      // if current value is negative, make it positive and vice versa
      const newValue = currentValue < 0 ? Math.abs(currentValue) : -Math.abs(currentValue)
      setQuestionAnswer(newValue)
    }
  }

  return <div className={`w-full flex flex-col gap-4 items-center`}>



    <div className={`w-full flex flex-row gap-1`}>

 
        <button
          onClick={togglePositiveOrNegative}
          className={`bg-white rounded p-2 font-bold`}
        >
          +/-
        </button>
 
  

      <input
        className={`bg-white text-center drop-shadow-lg border border-gray-300 text-gray-900 rounded hover:opacity-90-lg focus:ring-blue-500 focus:border-blue-500 block w-full text-lg px-5 py-3`}
        onChange={(e) => setQuestionAnswer(e.target.value)}
        type={`number`}
        inputMode={/iPhone|iPad|iPod/.test(navigator.userAgent) ? 'text' : `numeric`} // the pattern below means 0 to 9, minus signs and a decimal point
        step='any'
        pattern='-?[0-9]*[.,]?[0-9]*'
        value={defaultValue || ''}
      />

      {thisQuestion && thisQuestion.MeasurementUnit && <p className={`pl-2`}>{thisQuestion.MeasurementUnit}</p>}
    </div>



    <DisplayAverage
      question={thisQuestion}
      classString="text-xl italic"
      classString2="text-xl font-bold "
      checkPeriodId={checkPeriodId || ''}
      questionAnswer={questionAnswerValue}
    />

  </div>
}

export default QuestionNumber

